<template>
  <v-page page="monitor">
    <v-layout v-if="isProduction">
      <v-flex
        class="py-5 text-xs-center"
        v-show="iframeLoading">
        <v-progress-circular
          class="mt-5"
          :size="100"
          color="primary"
          indeterminate>
        </v-progress-circular>
      </v-flex>
      <v-flex
        v-show="!iframeLoading">
        <vue-friendly-iframe
          @document-load="onLoad"
          :src="redashUrl"
          frameborder="0"
          className="iframe" />
      </v-flex>
    </v-layout>
    <v-layout v-if="!isProduction">
      <v-flex>
        <v-alert
          :value="true"
          type="warning"
          transition="scale-transition">
          Unfortunately, the monitoring dashboard is only available in the production version of the Hub.
        </v-alert>
      </v-flex>
    </v-layout>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import VueFriendlyIframe from 'vue-friendly-iframe'
import CurrentSession from '@/mixins/CurrentSession.vue'

export default {
  name: 'Monitor',
  // @TODO: Remove mixin `isProduction` var once dv and st Redash dashes exist
  mixins: [CurrentSession],
  components: {
    VPage,
    VueFriendlyIframe
  },
  data () {
    return {
      iframeLoading: true,
      prefixRedash: 'https://redash.imbellus.com/public/dashboards/',
      // @TODO: Pull out Alex's email as default parameter
      companyKeys: {
        'Imbellus': 'lIUAKnn6toKvmgs4RnFTMnONSDuCctUgOoqq5fRS?p_Created%20By=amckaie2@imbellus.com&org_slug=default&refresh=600?fullscreen',
        'McKinsey': 'SHmLGBxCZdiZRmaphpQPccvZjE2E1w7xvksuWxn6?org_slug=default&refresh=600?fullscreen'
      }
    }
  },
  computed: {
    currentCompany () {
      const companyId = this.$store.getters['auth/companyId']
      return this.$store.getters['companies/companyName'](companyId)
    },
    // Below property will switch the Redash URL as the company switcher changes
    // @TODO: Pull out logic from Monitor.vue and put into store.js eventually
    redashUrl () {
      return this.prefixRedash + this.companyKeys[this.currentCompany]
    }
  },
  methods: {
    onLoad () {
      setTimeout(() => {
        this.iframeLoading = false
      }, 500)
    }
  }
}
</script>

<style lang="sass">
.iframe
  width: 100%
  height: 100vh
</style>
